import { Component } from '@angular/core';

@Component({
  selector: 'app-social-responsibility-investment',
  templateUrl: './social-responsibility-investment.component.html',
  styleUrl: './social-responsibility-investment.component.scss'
})
export class SocialResponsibilityInvestmentComponent {

}
